import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

const Filtro = {
    fechaInicial: '',
    fechaFinal: '',
    idVehiculo: 0,
    token: ''
}

export const useRecorridosStore = create(devtools((set) => ({
    filtro: Filtro,
    setFechas: (obj) => {
        set((state) => ({

            filtro: { ...state.filtro, fechaInicial: obj.fechaInicial, fechaFinal: obj.fechaFinal },
        }))
    },
    setVehiculo: (obj) => {
        set((state) => ({

            filtro: { ...state.filtro, idVehiculo: obj.idVehiculo },
        }))
    },
    setToken: (obj) => {
        set((state) => ({

            filtro: { ...state.filtro, token: obj.token },
        }))
    },
})))